<template>
  <div class="bg-gray-900 rounded-lg shadow-lg p-8 border border-gray-700 dark-card">
    <h1 class="text-4xl font-bold text-center mb-8 text-white">
      <i class="fas fa-flag-checkered mr-3"></i>
      Riepilogo Meeting
    </h1>
    
    <!-- Total Time -->
    <div class="text-center mb-8">
      <h2 class="text-2xl font-bold text-white mb-2">Tempo Totale</h2>
      <div class="text-6xl font-mono font-bold text-blue-400">
        {{ formatTime(totalElapsedTime) }}
      </div>
    </div>
    
    <!-- Phase Breakdown -->
    <div class="grid gap-4 mb-8">
      <h3 class="text-xl font-bold text-white text-center">Dettaglio per Fase</h3>
      <div 
        v-for="(phase, index) in phases" 
        :key="index" 
        class="flex justify-between items-center p-4 bg-gray-800 rounded-lg"
      >
        <span class="font-semibold text-white">{{ phase.title }}</span>
        <div class="text-right">
          <div 
            class="font-mono text-lg" 
            :class="getPhaseStatusClass(index)"
          >
            {{ formatTime(phaseElapsedTimes[index]) }}
          </div>
          <div class="text-sm text-gray-400">
            / {{ formatTime(phase.maxTime) }}
          </div>
          <div v-if="isPhaseOvertime(index)" class="text-xs text-red-300 mt-1">
            +{{ formatTime(phaseElapsedTimes[index] - phase.maxTime) }} overtime
          </div>
        </div>
      </div>
    </div>
    
    <!-- Performance Metrics -->
    <div class="text-center mb-8">
      <div class="grid grid-cols-2 gap-4">
        <div class="bg-gray-800 p-4 rounded-lg">
          <div class="text-sm text-gray-400">Fasi in Orario</div>
          <div class="text-2xl font-bold text-green-400">
            {{ onTimePhases }} / {{ phases.length }}
          </div>
        </div>
        <div class="bg-gray-800 p-4 rounded-lg">
          <div class="text-sm text-gray-400">Tempo Pianificato</div>
          <div class="text-2xl font-bold text-blue-400">
            {{ formatTime(plannedTime) }}
          </div>
        </div>
      </div>
    </div>
    
    <!-- Restart Button -->
    <div class="text-center">
      <button 
        @click="$emit('restart-meeting')"
        class="px-8 py-4 text-xl font-bold text-white bg-green-500 hover:bg-green-600 rounded-lg shadow-lg btn-primary"
      >
        <i class="fas fa-redo mr-2"></i>
        Nuovo Meeting
      </button>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import { TimeUtils } from '@/utils/TimeUtils.js';

export default {
  name: 'MeetingSummary',
  props: {
    phases: {
      type: Array,
      required: true
    },
    phaseElapsedTimes: {
      type: Array,
      required: true
    },
    totalElapsedTime: {
      type: Number,
      required: true
    }
  },
  emits: ['restart-meeting'],
  setup(props) {
    const formatTime = TimeUtils.formatTime;

    const isPhaseOvertime = (index) => {
      return props.phaseElapsedTimes[index] > props.phases[index].maxTime;
    };

    const getPhaseStatusClass = (index) => {
      return isPhaseOvertime(index) ? 'text-red-400' : 'text-green-400';
    };

    const onTimePhases = computed(() => {
      return props.phases.filter((_, i) => !isPhaseOvertime(i)).length;
    });

    const plannedTime = computed(() => {
      return props.phases.reduce((sum, phase) => sum + phase.maxTime, 0);
    });

    return {
      formatTime,
      isPhaseOvertime,
      getPhaseStatusClass,
      onTimePhases,
      plannedTime
    };
  }
};
</script>